<template>
    <div class="page bg-gray">
        <backTitleBar></backTitleBar>
        <div class="floor-list">
            <div class="floor-item" v-for="(layer,layerIndex) in curZone.wayItemInfoVOList" :key="layerIndex">
                <div class="title">{{layer.layerInfo}}</div>
                <div class="floor-product-list">
                    <div class="item" v-for="(item,productIndex) in layer.wayItemVOList" :key="productIndex">
                        <div class="item-img">
                            <img :src="item.mainPicView" alt="">
                        </div>
                        <div class="item-info">
                            <div class="p1">货道{{item.wayCode}}</div>
                            <div class="p2">{{item.productName}}</div>
                            <div class="p3">¥{{item.displayPrice != null ? item.displayPrice : item.specialPrice}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed-btn-box">
            <div class="btn click" @click="next">确定{{descpName}} <span>({{descpName}}后，请关门盘点库存)</span></div>
        </div>
    </div>
</template>

<script>
    import {queryShopZoneWayItemList} from "@/api/shop"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "supplyCompare",
        components:{backTitleBar},
        mixins: [],
        computed:{
            'descpName':function(){
                if(this.isCabinetToolBuyerRole){
                    return '取货'
                }else{
                    return '补货'
                }
            }
        },
        data(){
            return {
                img: require("../../assets/images/full.png"),
                show: false,
                timer:null,
                time: 5,
                shopId:'',
                curZone:{
                    wayItemInfoVOList:[]
                },
                isCabinetToolBuyerRole: this.$store.state.user.isCabinetToolBuyerRole || false,
            }
        },
        created() {
            if(this.$route.query.shopId){
                this.shopId = this.$route.query.shopId;
            }
            this.getZoneItemList();
        },
        methods:{
            next(){
                let _this = this;
                this.$toast({
                    type: 'loading',
                    message: '正在盘点中...',
                    mask: true,
                    duration: 0
                })
                this.timer = setInterval(function(){
                    _this.time -= 1;
                    if(_this.time <= 0){
                        clearInterval(_this.timer);
                        _this.$toast.clear();
                        _this.$router.replace({name:'supplyRecordList'})
                    }
                },1000)
            },
            getZoneItemList(){
                let params = {
                    shopId: this.shopId
                }
                queryShopZoneWayItemList(params).then(res=>{
                    this.curZone = res.data[0];
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .floor-list{
        padding: .12rem .24rem 1.1rem;
        .floor-item{
            background: #fff;
            border-radius: .12rem;
            margin-bottom: .16rem;
        }
        .title{
            height: .5rem;
            line-height: .5rem;
            padding: 0 .16rem;
            background: $main-color;
            color: #fff;
            font-size: .28rem;
            width: 1.2rem;
            border-radius: 0 .12rem .12rem 0;
        }
        .floor-product-list{
            padding: .24rem;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .item{
                margin-top: .24rem;
                display: flex;
                width: 3.2rem;
                &:nth-child(1),&:nth-child(2){
                    margin-top: 0;
                }
                &:nth-child(2n+1){
                    margin-right: .14rem;
                }
                .item-img{
                    width: 1.4rem;
                    height: 1.4rem;
                }
                .item-info{
                    flex: 1;
                    padding-left: .12rem;
                }
                .p1{
                    font-size: .28rem;
                    line-height: .34rem;
                    font-weight: 600;
                    color: $main-color;
                }
                .p2{
                    font-size: .28rem;
                    line-height: .34rem;
                    color: #333;
                    margin-top: .08rem;
                    height: .68rem;
                    overflow: hidden;
                }
                .p3{
                    font-size: .24rem;
                    line-height: .34rem;
                    color: red;
                    margin-top: .08rem;
                    height: .68rem;
                    overflow: hidden;
                }
            }
        }
    }
    .fixed-btn-box{
        position: fixed;
        z-index: 200;
        width: 100%;
        height: .98rem;
        padding: .1rem .2rem;
        background: #fff;
        left: 0;
        bottom: 0;
        .btn{
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: .78rem;
            font-size: .3rem;
            color: #fff;
            border-radius: .12rem;
            background: $main-color;
            span{
                font-size: .24rem;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// supplyCompare.vue?1f21f3d4